export default __webpack_public_path__ + "static/media/PrawdekTransparent.b7fd1e78.png";